"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

exports.File = function (_a) {
  /*
    File fields cannot be managed via the EE. We never output "editable."
  */
  var field = _a.field,
      children = _a.children,
      otherProps = __rest(_a, ["field", "children"]);

  var dynamicField = field;

  if (!field || !dynamicField.value && !dynamicField.src) {
    return null;
  } // handle link directly on field for forgetful devs


  var file = dynamicField.src ? field : dynamicField.value;

  if (!file) {
    return null;
  }

  var linkText = !children ? file.title || file.displayName : null;
  var anchorAttrs = {
    href: file.src
  };
  return react_1.default.createElement('a', __assign(__assign({}, anchorAttrs), otherProps), linkText, children);
};

exports.File.propTypes = {
  field: prop_types_1.default.oneOfType([prop_types_1.default.shape({
    src: prop_types_1.default.string
  }), prop_types_1.default.shape({
    value: prop_types_1.default.object
  })]).isRequired,
  children: prop_types_1.default.node
};
exports.File.displayName = 'File';